import { render, staticRenderFns } from "./Rwsq.vue?vue&type=template&id=038dd120&scoped=true&"
import script from "./Rwsq.vue?vue&type=script&lang=js&"
export * from "./Rwsq.vue?vue&type=script&lang=js&"
import style0 from "./Rwsq.vue?vue&type=style&index=0&id=038dd120&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038dd120",
  null
  
)

export default component.exports